"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _antd = require("antd");
require("./app-footer.less");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  Footer
} = _antd.Layout;
class AppFooter extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(Footer, {
      className: "app-footer"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "copyright"
    }, "Copyright \xA9 ", new Date().getFullYear(), " BI WORLDWIDE\xAE All Rights Reserved."));
  }
  handleFeedbackClick = e => {
    e.preventDefault();
    const {
      onFeedbackClick
    } = this.props;
    if (typeof onFeedbackClick === 'function') {
      onFeedbackClick();
    }
  };
}
var _default = exports.default = AppFooter;
//# sourceMappingURL=app-footer.js.map